import React, { Component } from 'react';
import { DataEcheancier, IDS_ECHEANCIERS } from '../../data/DataEcheancier';
import { EUIComboBox } from '../EUI/EUIComboBox';

export class ComboBoxEcheancier extends Component {

    static defaultProps = {
        idOperation: null,
        inclureNouvelEcheancier: false,
        inclureEcheancierType: false,
        label: "Échéancier",
        placeholder: "Échéancier",
        name: "comboEcheancier"
    };

    render = () => {

        const { idOperation, inclureEcheancierType, inclureNouvelEcheancier } = this.props;
        const { NEW, TYPE } = IDS_ECHEANCIERS;

        let extractItems = null;
        if (inclureNouvelEcheancier || inclureEcheancierType) {
            extractItems = (reponseAPIobjet) => {
                let items = EUIComboBox.defaultProps.extractItems(reponseAPIobjet);
                if (inclureEcheancierType) items.unshift({ idEcheancier: TYPE, nomEcheancier: "Échéancier type" });
                if (inclureNouvelEcheancier) items.unshift({ idEcheancier: NEW, nomEcheancier: "Nouvel échéancier" });
                return items;
            }
        }
        else extractItems = EUIComboBox.defaultProps.extractItems;

        let fetchMethod = null;
        if (!!idOperation)
            fetchMethod = () => DataEcheancier._chargementEcheanciers({ idOperation, inclureEcheancierType }, "NomEcheancier", false);

        return <EUIComboBox
            {...this.props}
            extractItems={extractItems}
            fetchMethod={fetchMethod}
            itemKey={item => item.idEcheancier}
            itemText={item => item.nomEcheancier}
        />;

    };

};